var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCSharp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 225,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0 3 L 380.5 3 L 381 8 L 0.5 8 L 0 3 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 15 L 208 18 Q 202.8 19.7 204 16 L 206.5 15 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176 16 L 183.5 16 L 186.5 18 L 199 20 L 199.5 18 Q 204 19.5 204.5 25 L 207.5 24 L 210.5 28 Q 213.1 27.3 212 30 L 214.5 30 L 214.5 32 L 219 31 L 219.5 33 L 221.5 32 L 222.5 35 L 224 35.5 L 222.5 38 L 222 35 L 219.5 34 L 218 34.5 L 218.5 33 L 216.5 32 L 214.5 33 Q 212 28.2 206 28 Q 207.1 25.3 204.5 26 L 200.5 24 L 192.5 20 L 184.5 24 L 183 23.5 Q 183.8 25.8 181.5 25 L 177.5 28 L 176 25 Q 172.2 24 171 26.5 L 171.5 28 L 169 28.5 L 172.5 30 L 175.5 28 L 174.5 30 L 170 31 Q 171.1 33.7 168.5 33 L 166 34.5 Q 164.3 29.7 168.5 31 L 168 29.5 Q 166.5 25.1 169.5 26 L 169.5 25 L 168 24.5 L 181 23 L 182 18 L 176 18 L 176 16 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 16 L 190 16.5 L 187.5 17 L 187.5 16 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 26 L 216 27.5 L 214.5 28 L 213.5 26 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144 32 L 155.5 32 L 156 34 L 151.5 35 L 150.5 34 L 144 34 L 144 32 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230 32 L 235 32 L 235 34 L 230 34 L 230 32 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 34 L 165 35.5 L 160.5 38 L 161.5 36 L 163 35.5 L 162.5 34 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 39 L 151.5 41 L 153 41.5 L 149.5 43 L 146 40.5 L 151.5 39 Z "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 235.5 39 Q 240.3 37.7 239 41 Q 236.3 39.9 237 42.5 L 238.5 42 Q 241.1 41.2 240 44.5 L 237.5 46 L 234.5 41 L 233 40.5 L 235.5 39 Z "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 41 L 146.5 44 L 144 43.5 L 144.5 41 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 43 L 210 45.5 L 208 44.5 L 208.5 43 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 45 L 215 45.5 L 211.5 47 L 211.5 46 L 213.5 45 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192 46 L 195 46.5 L 192 48 L 192 46 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 47 L 117 48 L 115.5 51 L 112.5 53 L 111 48.5 L 112.5 47 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125 48 Q 129.1 46.7 128 50 Q 123.9 51.3 125 48 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246.5 48 Q 248 51.5 249.5 49 Q 252.8 47.9 252 50.5 L 255 51.5 Q 254.3 54.1 257 53 L 257 55.5 L 257.5 57 L 255 57 Q 256.1 54.3 253.5 55 L 248 51.5 L 246.5 48 Z M 250 50 L 251 52 L 252 52 L 250 50 Z M 254 51 L 252 53 L 254 53 L 254 51 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 257 48 L 259 48.5 L 257 49.5 L 257 48 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130 50 L 134.5 51 L 136 50.5 Q 136.8 52.8 134.5 52 L 134.5 54 L 132.5 53 L 130.5 54 L 128 52.5 L 130 52 L 130 50 Z M 132 51 L 130 53 L 132 53 L 132 51 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 261.5 54 L 265 55.5 Q 264.3 57.8 266.5 57 L 268.5 56 L 268 57.5 Q 267.3 59.8 269.5 59 L 272 60.5 L 269 61.5 L 272 62 L 271.5 64 L 269.5 64 L 264 60.5 L 268 59.5 L 261 57 Q 262 60 259 59 L 259 55 L 260.5 55 L 261.5 54 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 55 L 124.5 57 L 127 56 Q 128.8 60.5 123.5 59 L 122 59.5 L 123 57.5 L 121 57 L 118.5 61 Q 116.3 60.3 117 62.5 L 115 63.5 L 115 61.5 L 119 57.5 L 118.5 56 L 120.5 55 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 55 L 228 55.5 L 225.5 56 L 225.5 55 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 56 L 117 57.5 L 112.5 61 L 116.5 56 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233.5 59 L 233 60.5 L 232.5 62 L 232 60.5 L 233.5 59 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 236.5 60 L 237 62 L 234.5 63 L 236.5 60 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 61 L 241 61.5 L 236.5 64 L 236.5 63 L 239.5 61 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 62 L 114 68 L 112 67.5 L 112 65.5 L 112.5 62 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 242.5 62 L 246 63.5 L 244.5 64 L 242.5 63 L 240.5 64 L 240.5 63 L 242.5 62 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 71 L 113 143.5 L 112 143.5 L 112.5 71 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 257.5 72 L 260 72.5 Q 257.5 74 259 79.5 L 260 79.5 L 260.5 76 L 261 79.5 L 260 80.5 L 260 135.5 L 258.5 144 L 258 136.5 L 259 135.5 L 259 128 L 256 127.5 L 256 88.5 L 257 87.5 L 258 76.5 L 257 76.5 L 256.5 78 L 256 76 L 250.5 79 L 250.5 78 Q 252.8 78.8 252 76.5 L 256 75 L 257.5 72 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 245.5 80 L 248 83.5 L 245.5 82 L 244 81.5 L 245.5 80 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272 80 L 274 80.5 L 274 144 L 272 143.5 L 272 80 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 278 80 L 280 80.5 L 280 144 L 278 143.5 L 278 80 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 242.5 82 L 241.5 84 L 239 85.5 L 240 88 L 232.5 88 L 232 91 L 229.5 91 L 228.5 93 Q 233.3 91.7 232 95 L 228 96.5 L 227.5 98 Q 225.5 94 223.5 98 Q 219.1 99.5 220 96.5 L 219.5 95 L 224.5 93 L 224.5 95 L 228 93.5 L 226 92.5 Q 232.6 85.6 242.5 82 Z M 221 95 L 221 97 L 224 96 L 221 95 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243 85 L 248 86 Q 249.3 89.3 244.5 88 L 243 85 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 96 L 232 97.5 Q 230.5 100.5 229 97.5 L 231.5 96 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238 96 L 240 96 L 240 102 L 238 102 L 238 96 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 97 L 215 98.5 L 214.5 100 L 214 98.5 L 215.5 97 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 98 L 197 101.5 L 195 102 L 194.5 104 L 192 103.5 L 193 100.5 L 192.5 98 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 100 L 233 100.5 L 233 104 Q 235.7 102.9 235 105.5 L 236 109.5 Q 233.5 111 237 112.5 L 233.5 117 L 233 114.5 L 234 110.5 L 233 104 Q 230 105.3 231 101.5 L 230.5 100 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 101 L 209.5 104 L 211 104.5 L 209 105 L 209 107 Q 206.3 105.9 207 108.5 L 205.5 108 Q 203.3 108.8 204 106.5 L 203.5 105 L 205.5 106 L 206.5 103 Q 209 103.7 208.5 101 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 101 L 211.5 103 L 212.5 101 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 104 L 240 112 Q 236.3 113.3 238 107.5 L 239.5 104 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200 106 L 202 106.5 L 201 108.5 L 204 110 Q 203 113 206 112 Q 204.8 108.3 210 110 L 207.5 114 L 207.5 112 L 204.5 113 L 202 112 L 201 116.5 L 203.5 120 L 204 118 Q 209.2 115.9 208 120.5 L 206.5 124 L 205 123.5 L 207 122.5 L 203.5 122 L 202 122.5 L 201.5 121 L 199 122.5 L 199 120 Q 201.7 121.1 201 118.5 L 200 113.5 L 200.5 112 L 192.5 112 L 192 110 L 200 108 L 200 106 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 117 L 231.5 119 L 230.5 117 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 119 L 230 120.5 L 226.5 123 L 226 121.5 L 229.5 119 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 120 L 193.5 123 L 194.5 120 L 195 126 L 197 126.5 L 193.5 130 L 191 129.5 L 193 123.5 L 192.5 120 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 121 L 197 122.5 L 196.5 124 L 196 122.5 L 197.5 121 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 124 Q 214.3 127.1 216 125.5 L 215.5 128 L 212.5 126 L 209 126.5 L 212.5 124 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 125 L 230 127.5 L 227.5 128 Q 221.7 129.7 223 126 L 225.5 125 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 132 L 217.5 132 L 220 134.5 L 222.5 138 L 224 138.5 L 224 144 Q 221.3 145.1 222 142.5 L 221 139 L 216 139 L 216 140.5 L 214 139.5 L 215 137.5 Q 212.5 136 216 134.5 L 215.5 132 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256.5 136 L 257 142.5 L 256 142.5 L 256.5 136 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 142 L 212 142.5 L 210.5 145 Q 206.8 143.8 208 147.5 L 207 147.5 L 205 144.5 L 206.5 145 L 208 144.5 L 207.5 143 L 209 143.5 L 209.5 142 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 144 L 247 144.5 L 242.5 146 L 241.5 144 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 258.5 145 L 260.5 148 L 258.5 145 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 146 L 205 149 L 207 149.5 L 206 152 Q 203.3 153.1 204 150.5 Q 206.3 149.3 203.5 148 L 203 152 L 199 153 L 198.5 151 L 195.5 152 L 194.5 150 L 196.5 151 L 196.5 149 L 200.5 150 L 201 148 Q 203.8 149 203.5 146 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256.5 146 L 259 150 L 257 150.5 L 257.5 152 L 255 152 Q 256.1 154.7 253.5 154 L 251.5 153 L 249 154 L 247.5 158 L 240 157 L 240 152 L 248 152 L 248.5 154 L 251 152.5 L 250.5 151 Q 255 151.5 255.5 148 L 257 148.5 L 256.5 146 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 149 L 171.5 151 L 170 150.5 L 172.5 149 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 157 L 113.5 159 L 115 158.5 Q 115.7 161.5 112 160 L 112.5 157 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192 158 L 198.5 158 L 199.5 159 L 200.5 158 L 208 158 L 207.5 160 L 192 160 L 192 158 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 270.5 158 L 271 160 L 268 159.5 L 270.5 158 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 237.5 160 L 239.5 163 L 237 162 Q 238.1 164.7 235.5 164 L 234.5 162 Q 235.8 164.3 237 161.5 L 237.5 160 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116 161 Q 120.6 159.8 122 162.5 L 120 162.5 L 121 164.5 L 120 166.5 L 125.5 168 Q 130.8 166.8 132 169.5 Q 131.1 172.5 135.5 171 L 136.5 173 L 134 173.5 L 136 174 Q 137.1 177.5 129.5 176 L 129.5 174 L 128 173.5 L 130.5 172 L 132.5 173 L 131.5 171 L 128.5 170 L 123.5 171 L 117 165.5 L 116 161 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 262.5 161 Q 268.6 159.8 268 162.5 L 264.5 167 L 263 167.5 Q 265.7 169.3 261.5 171 L 257.5 172 L 257 170 L 253 169.5 L 255.5 167 L 257.5 167 L 259.5 166 Q 261.8 170.3 264 165.5 Q 265.5 161.1 262.5 162 L 262.5 161 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 162 L 234 164.5 L 232 164.5 L 230.5 168 L 227.5 169 L 225.5 168 L 222.5 169 L 221 168.5 L 223 167.5 L 223 165.5 L 223.5 164 L 225.5 167 L 227 164 L 232.5 162 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 169 Q 219.3 170.3 217 171.5 L 216.5 173 L 216 171.5 L 216.5 169 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 169 L 252 170 Q 249.8 175.6 255.5 174 L 255.5 175 L 251.5 176 L 251.5 174 L 248.5 173 Q 247.3 175.3 246 172.5 L 247 170 L 249.5 169 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244.5 173 Q 247.5 174.5 244.5 176 L 241.5 177 L 240 176.5 Q 241.5 180.9 238.5 180 L 238.5 181 L 240 181.5 L 236.5 184 L 234.5 183 L 234.5 185 Q 229.3 186.3 228 183.5 L 235.5 178 L 236 179.5 L 235.5 181 L 239 178.5 L 240 174 L 244.5 175 L 244.5 173 Z M 231 183 L 231 184 L 233 184 L 231 183 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 265.5 173 L 268 174 Q 269.2 177.7 264 176 L 265.5 173 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144 175 L 146 175.5 L 144 176.5 L 144 175 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 175 L 195 176 Q 196.2 179.7 191 178 L 192.5 175 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 175 L 215.5 177 L 216.5 175 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 178 L 148 182 Q 150.7 183.1 150 180.5 L 149.5 179 L 152.5 184 L 153.5 182 L 154 184 L 156.5 183 L 159 183.5 L 161.5 188 L 162.5 186 L 164 189.5 L 161.5 190 L 159.5 188 Q 151.5 189.5 149 185.5 Q 149.9 182.5 145.5 184 Q 142.5 182.5 145.5 181 Q 147.8 181.8 147 179.5 L 146.5 178 Z M 146 182 L 146 183 L 148 183 L 146 182 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 178 L 201 180 L 205 181.5 L 201 181.5 Q 201.5 186.5 197.5 187 L 195.5 187 L 191.5 189 L 191 186.5 L 192.5 184 L 193.5 185 L 198.5 180 Q 201 180.7 200.5 178 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 178 L 208 179.5 L 207.5 182 L 203.5 178 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222 185 Q 225 184 224 187 Q 221.3 185.9 222 188.5 L 215.5 193 L 214.5 191 L 216 190.5 L 215.5 189 L 217 189.5 Q 216.3 187.3 218.5 188 L 220 187.5 L 219.5 189 Q 221.8 189.8 221 187.5 L 222 185 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 187 L 167 188 L 168.5 191 L 172 191.5 L 172 193.5 L 173.5 196 Q 176.1 195.3 175 198 L 168 198 L 168 193 L 166.5 193 L 164.5 187 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144 189 L 149 190.5 Q 147.8 193 144 192 L 144 189 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234 190 L 240 190 L 240 192 L 234 192 L 234 190 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 198 L 182 200 L 179 199.5 L 181.5 198 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 198 Q 203.8 197.3 203 199.5 L 204 199.5 L 204.5 198 L 207 199.5 L 204 200 L 202.5 204 L 193.5 205 L 193.5 204 L 198 200.5 Q 197.2 197.9 200.5 199 L 201.5 198 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 200 L 184 202 L 190.5 201 L 192 202.5 Q 188.9 204.2 190.5 206 Q 183.5 207.5 184 204.5 L 182 201.5 L 183.5 200 Z M 185 203 Q 184 206 188 205 Q 189 202 185 203 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 205 L 208 208 Q 202.8 209.7 204 206 L 206.5 205 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176 206 Q 181.2 204.3 180 208 Q 174.8 209.7 176 206 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(121,47,152)",
    stroke: "rgb(121,47,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 207 L 194 207.5 L 190.5 208 L 190.5 207 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 30 L 206.5 32 L 205.5 30 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196.5 32 L 197.5 34 L 196.5 32 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 33 L 172.5 35 L 173.5 33 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 34 L 213.5 36 L 212.5 34 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 41 L 158.5 43 L 159.5 41 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 42 L 227.5 44 L 226.5 42 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 45 L 232.5 47 L 231.5 45 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 49 L 239.5 51 L 238.5 49 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 57 L 253.5 59 L 252.5 57 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 58 L 141.5 60 L 142.5 58 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 64 L 116.5 68 L 119.5 64 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 255.5 66 L 256.5 68 L 255.5 66 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 69 L 116 71.5 L 115 71.5 L 115.5 69 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 262.5 70 L 263 149.5 L 262 149.5 L 262.5 70 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 71 L 122 151.5 L 123 152.5 L 121 151.5 L 121.5 71 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 80 L 183 80.5 L 180.5 81 L 180.5 80 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 80 L 194 80.5 L 190.5 81 L 190.5 80 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 84 L 167.5 86 L 168.5 84 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 86 L 164.5 88 L 165.5 86 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 86 L 210.5 91 L 206.5 86 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 92 L 190 92.5 L 184.5 93 L 184.5 92 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 93 L 213.5 95 L 212.5 93 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196.5 95 L 197.5 97 L 196.5 95 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 96 L 170.5 101 L 174.5 96 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 98 L 201.5 101 L 199.5 98 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 99 L 220 99.5 L 216.5 100 L 216.5 99 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 223.5 99 L 227 99.5 L 223.5 100 L 223.5 99 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 219.5 102 L 220 104.5 L 219 104.5 L 219.5 102 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 103 L 216 105.5 Q 215 108 210.5 107 L 210.5 106 Q 216.5 107.9 215.5 103 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 105 L 230 106.5 L 226.5 107 L 225.5 105 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 219.5 106 L 222 106.5 L 219.5 107 L 219.5 106 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 110 L 167 116.5 L 166 116.5 L 166.5 110 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 217.5 112 L 220 113.5 L 217 114 L 217.5 112 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 112 L 229 113 L 228.5 117 L 228 114 Q 224.2 114.8 224.5 112 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 113 L 214 113.5 L 209.5 114 L 209.5 113 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 117 L 217 119.5 L 216 119.5 L 216.5 117 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 219.5 117 L 220 119.5 L 219 119.5 L 219.5 117 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 223.5 117 L 224 119.5 L 223 119.5 L 223.5 117 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 125 L 204 125.5 L 201.5 126 L 201.5 125 Z "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 126 L 171.5 128 L 170.5 126 Z "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 127 L 196.5 132 L 200.5 127 Z "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 129 L 174.5 131 L 173.5 129 Z "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 132 L 212.5 134 L 213.5 132 Z "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 133 L 159.5 135 L 158.5 133 Z "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 134 L 190 134.5 L 184.5 135 L 184.5 134 Z "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 210.5 136 L 207.5 140 L 210.5 136 Z "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 139 L 165.5 141 L 164.5 139 Z "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 141 L 170 142.5 L 168.5 143 L 167.5 141 Z "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 146 L 184 146.5 L 180.5 147 L 180.5 146 Z "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 146 L 193 146.5 L 190.5 147 L 190.5 146 Z "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 262.5 151 L 261.5 153 L 262.5 151 Z "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 153 L 125.5 155 L 124.5 153 Z "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 155 L 118.5 158 L 116.5 155 Z "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 159 L 123.5 161 L 122.5 159 Z "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 160 L 246.5 162 L 247.5 160 Z "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 164 L 144.5 166 L 143.5 164 Z "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 166 L 248.5 168 L 249.5 166 Z "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 168 L 151.5 170 L 150.5 168 Z "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233.5 168 L 232.5 170 L 233.5 168 Z "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 171 L 227.5 173 L 225.5 174 L 226.5 172 L 228.5 171 Z "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 172 L 158.5 174 L 157.5 172 Z "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 237.5 173 L 236.5 175 L 237.5 173 Z "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 179 L 213.5 181 L 214.5 179 Z "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 185 L 215.5 187 L 216.5 185 Z "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 186 L 201.5 188 L 199.5 189 L 200.5 187 L 202.5 186 Z "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 187 L 184.5 189 L 183.5 187 Z "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 191 L 192.5 193 L 191 192.5 L 193.5 191 Z "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 193 L 182.5 195 L 181.5 193 Z "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 196 L 196.5 198 L 197.5 196 Z "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,136,186)",
    stroke: "rgb(171,136,186)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 198 L 194 198.5 L 190.5 199 L 190.5 198 Z "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,241,250)",
    stroke: "rgb(249,241,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 24 L 197.5 26 L 268 67.5 L 269 70.5 L 269 151.5 L 267 157 L 195.5 198 L 188.5 198 L 129.5 164 L 116 154.5 L 115 151.5 L 115 72.5 L 116 68.5 L 120.5 64 L 191.5 24 Z M 192 30 L 124 69 L 121 72 L 121 152 L 192 193 L 262 153 L 263 152 L 263 70 L 192 30 Z "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,241,250)",
    stroke: "rgb(249,241,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 80 Q 204.3 79.7 212 92.5 L 214 95.5 L 202.5 102 L 196.5 95 L 189.5 92 L 184.5 92 Q 174.5 93.5 170 100.5 Q 165.6 106.1 166 116.5 Q 167.5 126.5 174.5 131 Q 179.8 135.2 189.5 135 Q 197.2 133.2 201 127.5 Q 200.1 124.5 204.5 126 L 214 131.5 L 204.5 142 L 195.5 146 L 184.5 147 L 174.5 145 Q 165.8 141.8 160 135.5 Q 151.3 127.2 152 109.5 Q 153.5 100 158 93.5 L 163.5 88 L 171.5 83 L 183.5 80 Z "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,241,250)",
    stroke: "rgb(249,241,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216 100 L 220 100 L 220 101.5 L 219 107 Q 222.7 108.5 222 105.5 L 223 100 L 227 100 L 227 101.5 L 225 105.5 Q 226.2 108 230 107 L 230 110 L 225 110 L 225 111.5 Q 222.7 112.8 225.5 114 Q 229.7 112.9 228 117 Q 220.5 114.3 223 122.5 L 219 124 L 220 117 Q 213.6 114.7 216 122.5 L 212 124 L 213 117 Q 207.4 118.9 209 114 L 214 114 L 214 111.5 L 214.5 110 Q 208.2 111.9 210 107 Q 214.6 108.3 216 105.5 L 216 100 Z M 218 110 L 217 114 L 221 113 Q 222 108 218 110 Z "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0 0 L 380.5 0 L 381 3 L 0.5 3 L 0 0 Z "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0 8 L 381 8 L 381 225 L 0 225 L 0 8 Z M 207 15 L 204 16 Q 203 20 208 18 L 207 15 Z M 176 16 L 176 18 L 182 18 L 181 23 L 168 25 L 170 25 L 170 26 Q 167 25 168 30 L 169 31 Q 164 30 166 36 L 146 47 L 143 50 L 141 49 L 141 51 L 132 55 L 132 53 Q 129 52 130 56 L 128 57 L 126 56 L 126 58 L 124 57 Q 120 58 121 62 L 117 64 L 115 67 L 113 62 L 112 66 L 112 68 L 114 68 L 113 70 L 114 72 L 112 72 L 112 144 Q 115 145 113 152 Q 110 153 114 155 L 113 157 L 115 157 L 114 159 L 113 157 L 112 160 Q 115 161 117 158 L 116 160 L 120 161 L 116 161 L 119 167 L 121 166 L 120 164 L 121 162 L 121 164 L 124 163 L 123 165 Q 122 167 125 166 L 126 164 L 138 172 L 142 173 L 142 175 Q 145 174 144 177 L 146 176 L 156 182 Q 159 181 158 184 L 156 184 L 153 182 L 153 184 L 151 183 L 152 180 Q 149 179 150 182 L 146 183 L 146 184 Q 150 182 149 186 L 153 188 L 160 188 L 164 190 L 163 189 L 165 188 L 164 187 L 164 186 L 166 188 L 165 190 Q 162 191 167 193 L 168 193 L 168 198 L 175 198 Q 176 195 174 196 L 172 194 L 172 192 L 171 191 L 166 191 L 167 188 L 176 192 Q 179 194 178 196 L 180 195 L 180 197 L 183 198 L 180 199 L 180 200 L 185 199 L 187 199 L 189 200 L 190 202 Q 183 203 184 201 L 182 202 L 184 205 Q 184 208 191 206 L 190 205 L 198 199 L 198 201 L 194 204 L 194 205 L 203 204 L 204 203 L 203 200 L 205 200 L 207 200 L 201 198 L 205 196 Q 207 197 206 195 L 208 195 L 208 194 L 213 191 Q 215 192 214 190 L 216 190 L 217 188 L 217 190 L 215 191 L 216 193 L 224 189 L 221 187 L 221 186 L 223 187 Q 226 188 224 184 L 236 177 L 238 178 L 238 175 L 241 176 L 245 174 L 246 171 L 250 174 Q 254 175 252 170 L 250 170 L 256 166 L 258 166 L 263 164 L 263 162 Q 265 161 264 164 L 263 167 L 265 167 L 268 161 L 264 161 L 267 160 L 271 155 L 271 153 L 271 72 L 272 70 L 271 70 L 270 65 L 266 63 L 265 61 L 270 64 L 272 64 L 272 62 L 263 59 Q 260 60 261 57 L 265 59 Q 269 60 268 58 L 269 56 L 265 57 L 264 54 L 261 55 Q 258 54 259 58 L 255 59 L 255 58 L 249 53 Q 246 54 247 52 L 246 52 L 245 49 L 243 50 L 242 49 L 241 49 L 240 48 L 239 48 L 234 45 L 236 44 L 238 44 L 240 45 L 240 42 L 239 42 L 237 42 L 239 41 Q 240 38 236 39 L 236 43 L 234 42 L 231 43 L 231 42 L 226 40 L 223 37 L 224 35 L 221 36 L 219 36 L 208 30 L 211 29 L 212 30 Q 213 27 211 28 L 208 24 L 204 26 L 206 26 L 206 29 L 204 28 Q 200 26 204 25 L 204 23 L 200 18 L 199 20 L 200 21 L 197 19 L 187 18 L 184 16 L 176 16 Z M 188 16 L 188 17 L 190 17 L 188 16 Z M 193 16 L 195 18 L 197 18 L 193 16 Z M 207 19 L 205 22 L 208 23 L 207 19 Z M 213 30 Q 213 34 215 31 L 213 30 Z M 217 31 L 219 33 Q 220 30 217 31 Z M 144 32 L 144 34 L 151 34 L 152 35 L 156 34 L 156 32 L 144 32 Z M 160 32 L 160 34 L 163 35 L 163 33 L 160 32 Z M 221 32 L 219 34 L 222 35 L 222 33 L 221 32 Z M 230 32 L 230 34 L 235 34 L 235 32 L 230 32 Z M 146 36 Q 143 38 146 39 L 148 38 Q 149 35 146 36 Z M 162 36 L 161 38 L 163 37 L 162 36 Z M 147 40 L 148 42 L 151 41 L 147 40 Z M 152 41 Q 152 45 154 42 L 152 41 Z M 146 42 L 144 44 L 145 45 L 147 44 L 146 42 Z M 113 47 L 111 49 L 113 53 L 116 51 L 117 48 L 113 47 Z M 125 48 L 125 50 L 129 50 L 125 48 Z M 257 48 L 257 50 L 259 49 L 257 48 Z M 133 49 L 131 50 L 129 53 L 132 51 L 132 53 L 137 52 L 136 50 L 134 51 L 134 50 L 133 49 Z M 248 49 L 248 52 L 256 57 L 258 57 L 257 54 Q 255 48 248 49 Z M 119 51 L 121 54 L 126 53 L 119 51 Z M 117 56 L 114 60 L 117 58 L 117 56 Z M 119 56 L 119 58 L 115 62 L 115 64 L 117 63 Q 116 60 119 61 L 121 58 L 119 56 Z M 269 59 L 270 61 L 272 61 L 269 59 Z M 272 80 L 272 144 L 274 144 L 274 81 L 272 80 Z M 278 80 L 278 144 L 280 144 L 280 81 L 278 80 Z M 271 158 L 268 160 L 271 160 L 271 158 Z M 260 166 L 258 167 L 256 167 Q 251 169 254 171 Q 253 174 256 173 L 255 171 L 257 170 L 258 172 L 262 171 L 264 169 L 260 166 Z M 123 167 L 121 169 Q 122 172 128 171 L 130 171 Q 133 172 132 170 L 129 167 L 127 168 L 123 167 Z M 133 171 L 133 173 L 128 172 Q 127 175 130 174 L 130 176 L 137 176 L 135 174 L 135 173 L 137 174 L 137 173 Q 136 170 133 171 Z M 266 173 L 264 176 Q 269 178 268 174 L 266 173 Z M 126 174 Q 126 178 128 175 L 126 174 Z M 147 177 L 147 180 Q 148 182 146 181 L 146 182 Q 149 183 148 180 L 150 180 L 147 177 Z M 144 189 L 144 192 Q 148 193 149 191 L 144 189 Z M 161 190 L 160 192 L 163 192 L 161 190 Z M 234 190 L 234 192 L 240 192 L 240 190 L 234 190 Z M 179 197 L 178 199 L 180 198 L 179 197 Z M 176 201 L 176 204 Q 180 205 179 203 L 176 201 Z M 207 201 Q 205 204 208 203 L 207 201 Z M 207 205 L 204 206 Q 203 210 208 208 L 207 205 Z M 176 206 Q 175 210 180 208 Q 181 204 176 206 Z M 196 206 L 196 208 L 202 208 L 202 206 L 196 206 Z M 191 207 L 191 208 L 194 208 L 191 207 Z "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 20 Q 198.9 20.7 201 25.5 L 197.5 23 L 192.5 21 L 189.5 22 L 189.5 21 L 192.5 20 Z "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 22 L 188 22.5 L 185.5 24 L 186.5 22 Z "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 23 L 184 24.5 L 167.5 35 L 167.5 32 L 170 33 Q 168.8 30 172.5 31 L 172.5 30 L 169 28.5 L 172 27.5 Q 169.8 26.2 172.5 25 L 176 25.5 L 174 26.5 L 178.5 28 Q 182.2 26 180.5 24 L 183 25 L 183.5 23 Z M 175 28 L 174 30 L 177 29 L 175 28 Z "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 44 L 213 44.5 L 210.5 46 L 211.5 44 Z "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 50 L 255 53.5 L 253.5 53 Q 249.5 52.5 249.5 50 Z "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 259.5 73 L 261 75.5 L 260 79.5 L 260.5 81 Q 257.1 79.1 259.5 73 Z "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 254.5 76 Q 257.5 75.2 256 79 L 254 79.5 L 257 80 L 257 87.5 L 256 88.5 L 256 128 L 259 128 L 259 135.5 L 261 146.5 L 260 148.5 L 261 151 L 255.5 154 L 256.5 152 L 258 151.5 L 257.5 150 Q 259.8 150.8 259 148.5 L 257 147.5 L 256.5 149 L 255.5 148 L 252.5 151 L 250 151.5 L 252.5 153 L 254 152.5 L 253.5 155 L 249 156 L 248 152 L 240 152 L 240 156.5 L 240 158.5 L 240.5 161 L 245 158.5 L 242 157.5 L 245.5 157 L 247.5 158 L 249.5 157 L 249.5 158 Q 243.3 158.8 240.5 163 L 239.5 162 L 236.5 165 L 231.5 168 L 233 163.5 L 232.5 162 L 227 164 L 225.5 167 Q 224.3 164.8 223 167.5 Q 224.3 170.3 225.5 168 L 228 169.5 L 216.5 177 L 214.5 177 L 204.5 183 L 201 183 L 201.5 181 L 204.5 182 L 203.5 180 Q 200.2 181.1 201 178.5 L 202.5 176 Q 198.8 175.3 198 177.5 L 200 178 Q 201.1 180.7 198.5 180 L 192 185.5 L 192.5 183 L 196 180.5 L 192 178.5 L 195 178 Q 196.1 175.3 193.5 176 L 192 174.5 L 192 160 L 207.5 160 L 208 158 L 200.5 158 L 199.5 159 L 198.5 158 L 192 158 L 192 156 L 198 156 L 198 154 L 192.5 154 L 192 152.5 L 195 150.5 L 192 149.5 L 198.5 148 L 198.5 149 L 196 149.5 L 196.5 151 L 195 151.5 L 197.5 152 Q 200.5 151.5 200 147.5 L 199.5 146 L 201.5 146 L 204.5 144 L 205 146 Q 207.7 144.9 207 147.5 L 208 147.5 L 206 143.5 L 211 139.5 L 210 141.5 L 213 139.5 L 213.5 137 L 214 139.5 L 213 141.5 L 214.5 141 Q 217.1 141.7 216 139 L 220.5 139 Q 223.8 137.3 220 135.5 L 217.5 132 L 214.5 136 L 213 135.5 L 215 135 L 216 132.5 L 214.5 130 L 216 130.5 L 215.5 127 L 212 127.5 Q 211.3 125.3 213.5 126 Q 214.7 128.3 216 125.5 L 216.5 124 L 217 128 Q 220.8 129.5 220 126.5 L 223 125.5 Q 222.3 122.9 225 124 L 225 121.5 L 226 121.5 L 226.5 123 L 230 120.5 L 229.5 119 L 227.5 120 L 228.5 118 L 231 117.5 L 230.5 116 L 232 115.5 L 230 114.5 L 231 112.5 L 230.5 109 Q 232.8 109.8 232 107.5 L 230 107.5 L 231 105.5 L 228.5 99 L 227.5 101 L 227 99.5 L 229.5 95 Q 233.3 96 232 93 L 228.5 93 L 221 97 Q 219.8 94 223.5 95 L 229.5 91 L 232 91 L 232 88 L 239.5 88 L 240 86.5 Q 237.8 85.2 240.5 84 L 245.5 82 L 248 83.5 L 246 80.5 Q 252.1 80.1 254.5 76 Z M 243 85 L 245 88 Q 249 89 248 86 L 243 85 Z M 230 96 L 231 101 L 232 97 L 230 96 Z M 238 96 L 238 102 L 240 102 L 240 96 L 238 96 Z M 233 100 Q 230 101 231 105 L 233 104 L 233 100 Z M 233 104 L 234 111 L 233 113 L 235 116 L 237 113 Q 233 111 236 110 L 235 106 Q 236 103 233 104 Z M 240 104 L 238 108 Q 236 113 240 112 L 240 104 Z M 198 121 L 196 124 L 198 125 L 198 121 Z M 226 125 L 225 126 Q 222 125 223 128 Q 228 129 229 127 L 226 125 Z M 223 132 L 223 135 Q 226 134 223 132 Z M 257 136 L 256 143 L 257 143 L 257 136 Z M 259 136 L 258 144 L 259 144 L 259 136 Z M 223 138 L 221 140 L 222 143 Q 221 145 224 144 L 224 139 L 223 138 Z M 217 141 Q 214 143 217 144 Q 221 145 220 143 L 217 141 Z M 209 142 L 208 145 L 211 145 L 213 142 L 211 143 L 209 142 Z M 242 144 L 243 146 L 247 145 L 242 144 Z M 256 144 L 256 147 L 258 146 L 260 147 L 260 145 L 256 144 Z M 204 146 L 203 148 L 205 149 L 204 146 Z M 201 148 L 199 153 L 203 152 Q 205 147 201 148 Z M 244 148 L 244 150 L 249 150 L 249 148 L 244 148 Z M 206 149 L 204 151 Q 203 153 206 152 L 207 150 L 206 149 Z M 231 160 L 231 161 Q 235 161 236 164 Q 238 165 237 162 L 234 160 L 231 160 Z M 237 160 L 238 162 L 239 162 L 237 160 Z M 219 171 L 219 173 L 223 172 L 219 171 Z M 217 173 L 217 175 L 219 174 L 217 173 Z M 248 173 L 245 175 L 248 175 L 248 173 Z M 253 174 L 252 176 L 256 175 L 253 174 Z M 257 174 Q 256 177 259 176 Q 260 173 257 174 Z M 243 175 L 243 176 L 245 176 L 243 175 Z M 209 176 L 209 179 L 211 178 L 209 176 Z M 240 176 L 239 179 L 236 181 L 237 178 L 230 183 L 233 183 L 233 184 L 230 183 L 228 184 Q 229 186 235 185 L 235 183 L 238 184 L 237 183 L 239 183 Q 241 184 240 182 L 240 180 L 240 176 Z M 206 179 Q 206 183 208 180 L 206 179 Z "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 219.5 96 L 220 98 L 218 97.5 L 219.5 96 Z "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 96 L 226.5 98 L 224 97.5 L 225.5 96 Z "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 98 L 214 102.5 L 213 105 L 209 103.5 L 210 101 L 213 99.5 L 213.5 98 Z "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 98 L 221 99.5 L 220.5 101 L 220 99.5 L 221.5 98 Z "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 104 L 207 104.5 Q 204.9 107.8 204.5 104 Z "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 106 L 205.5 108 L 207 108.5 L 207.5 107 L 208 110 Q 205 109 206 112 L 209 113.5 L 207 113.5 L 205 116.5 L 207 117.5 L 204 118 L 203.5 120 L 201 116.5 L 202 112 Q 205 113 204 110 L 201 108.5 L 202.5 106 Z "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192 112 L 201 112.5 L 200 117.5 L 201 120 Q 198 118.8 199 122.5 L 202 121.5 L 202.5 123 L 207.5 121 L 207.5 123 L 210.5 124 L 212 123.5 Q 212.8 125.8 210.5 125 L 210.5 127 L 208 125.5 L 208.5 124 L 204.5 123 L 202.5 124 L 200.5 123 L 197.5 127 L 195 126 L 194.5 120 L 192.5 124 L 193 122.5 L 192 112 Z "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 124 L 219 126.5 L 218 126.5 L 218.5 124 Z "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 127 L 194.5 129 L 196.5 128 L 196.5 129 L 192 131 L 193.5 127 Z "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 184 L 160.5 186 L 159.5 184 Z "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 184 L 199.5 186 L 198.5 184 Z "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 187 L 196 187.5 L 193 188.5 L 193.5 190 Q 190.5 188.5 193.5 187 Z "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 187 L 221 188.5 L 219.5 189 L 218.5 187 Z "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(122,50,152)",
    stroke: "rgb(122,50,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185 203 Q 189.1 201.7 188 205 Q 183.9 206.3 185 203 Z "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 27 L 180.5 29 L 173.5 33 L 174.5 31 L 181.5 27 Z "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 31 L 193 31.5 L 191 32.5 L 192 37.5 L 190.5 43 L 190 37 L 188 37.5 L 188.5 39 L 185.5 38 L 182 40.5 L 186 42.5 L 185 46 L 183 46.5 L 185 47 L 185.5 67 L 187.5 64 L 188 70 L 185.5 69 L 183.5 73 L 181 73.5 L 181.5 75 L 176.5 73 L 176.5 74 L 178 74.5 L 176 78 Q 182 79.2 184.5 76 L 187 77 L 187.5 75 L 188 78 L 198 80.5 L 196.5 81 L 195.5 80 L 177.5 80 Q 165.3 83.8 158 92.5 Q 149.3 101.8 152 122.5 Q 153.3 129.7 158 133.5 L 155.5 134 L 153.5 132 L 152.5 133 L 149.5 132 L 148 132.5 L 148 131 L 152 131 L 152 129.5 L 152.5 128 Q 148.8 129.3 150 125.5 L 151 125.5 L 151.5 127 L 152 124.5 Q 150.8 121.8 149.5 124 Q 147.3 124.8 148 122.5 L 149 120.5 L 148 118.5 Q 150.8 115.8 150 109.5 L 147.5 104 L 146.5 108 L 145.5 104 L 145 108.5 L 146 109.5 L 147 121.5 L 146 121.5 L 145.5 116 L 144 121.5 L 146 127.5 Q 143.2 128.3 144 132.5 L 147 137 L 141 138 L 139.5 141 L 136 141 L 136 145 L 134.5 145 Q 133.3 142.8 128.5 144 L 128.5 145 Q 132.3 144 131 147 L 124.5 146 Q 121.9 147.4 122.5 152 L 122 71 L 127.5 68 L 128.5 70 L 130.5 66 L 139.5 61 L 140 63 L 138 63.5 L 145.5 64 L 143.5 61 L 141 62 L 142.5 59 L 144.5 59 L 156.5 51 L 158.5 54 L 153.5 56 L 151 55 L 152 57.5 L 151 60.5 L 151.5 62 L 153.5 61 L 155 61.5 L 156 58 L 160 58 L 160 56.5 Q 157.8 55.2 160.5 54 L 161.5 56 L 163.5 55 L 166.5 56 L 165 53.5 L 167.5 50 L 164.5 52 L 164 50 L 166 49.5 Q 164.3 46.3 162.5 50 Q 158.8 49 160 52 L 163 52.5 L 160.5 53 L 158.5 50 L 172.5 42 L 174.5 43 L 175.5 40 L 178.5 41 L 178.5 40 L 177 39.5 L 184.5 35 L 186.5 36 L 186.5 34 L 191.5 31 Z M 185 36 L 183 37 L 182 39 L 185 38 L 185 36 Z M 176 43 L 167 47 L 170 48 L 172 48 L 174 48 L 172 47 L 173 45 L 175 46 L 177 46 Q 180 47 179 45 L 176 43 Z M 176 56 L 176 64 L 177 66 L 180 66 Q 179 63 184 64 L 184 56 L 176 56 Z M 146 59 L 145 61 L 147 60 L 146 59 Z M 150 59 L 149 61 L 151 60 L 150 59 Z M 157 61 L 155 63 L 155 64 L 160 64 Q 162 60 157 61 Z M 136 65 L 136 67 L 135 70 L 137 71 L 139 70 L 143 72 L 144 71 L 140 67 L 140 65 L 136 65 Z M 127 70 L 125 71 L 125 73 Q 122 74 123 80 L 124 80 Q 123 77 126 78 L 126 76 L 131 75 L 133 71 L 130 70 L 130 72 L 127 70 Z M 136 77 L 133 79 L 137 81 L 139 80 Q 143 81 142 78 L 136 77 Z M 154 80 L 152 82 L 154 86 L 153 89 L 156 91 L 155 89 L 157 89 L 161 86 L 158 84 L 156 82 L 154 80 Z M 167 80 L 169 82 L 171 81 L 167 80 Z M 127 81 L 126 104 L 123 104 L 123 120 L 126 120 L 127 143 L 127 121 L 128 120 L 127 81 Z M 165 81 L 166 83 L 168 83 L 165 81 Z M 144 82 L 143 87 L 144 91 L 147 90 Q 148 85 146 84 Q 147 81 144 82 Z M 162 82 L 160 84 L 163 85 Q 164 87 165 85 L 165 83 L 162 84 L 162 82 Z M 161 87 L 159 89 L 161 89 L 161 87 Z M 158 89 L 159 91 Q 160 88 158 89 Z M 152 91 L 149 92 L 148 95 L 152 96 L 153 100 L 154 96 Q 150 94 153 93 Q 154 90 152 91 Z M 149 97 L 147 100 Q 146 103 149 104 L 151 101 L 149 97 Z M 136 136 L 136 138 L 141 138 L 141 136 L 136 136 Z "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 33 L 170.5 35 L 168.5 36 L 169.5 34 L 171.5 33 Z "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 33 L 196.5 35 L 195.5 33 Z "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 37 L 163.5 39 L 164.5 37 Z "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 219.5 37 L 220.5 39 L 219.5 37 Z "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 41 L 156.5 43 L 147.5 48 L 148.5 46 L 157.5 41 Z "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 42 L 188 44.5 L 187 44.5 L 187.5 42 Z "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 42 L 216 45.5 L 214.5 45 L 211.5 42 Z "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 46 L 237 47.5 L 235.5 47 L 234.5 46 Z "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 48 L 144.5 50 L 123.5 62 L 125.5 59 L 127.5 59 L 145.5 48 Z "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 48 L 188 55.5 L 187 55.5 L 187.5 48 Z "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189 48 L 191 48.5 L 191 69.5 L 189 68.5 L 190 64.5 L 190 62.5 L 189 48 Z "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 48 L 222.5 50 L 221.5 48 Z "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 254.5 57 L 255.5 59 L 254.5 57 Z "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 64 L 116 66.5 L 115 68.5 L 114.5 154 L 114 68.5 L 117.5 64 Z "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 261.5 76 L 262 87.5 L 261 87.5 L 261.5 76 Z "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 81 L 207 84 L 206.5 86 L 199.5 82 L 199.5 81 Z "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 92 L 216 94.5 L 214 93.5 L 214.5 92 Z "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 93 L 192 94.5 L 188.5 95 L 186.5 94 L 182 95.5 L 185 96.5 L 185 103.5 L 182.5 104 L 180 103 Q 181.1 100.3 178.5 101 L 176.5 98 Q 172.7 100.2 178 102.5 L 178 110.5 L 179.5 111 Q 180.6 113.8 184 113 L 184.5 111 L 185 116 L 178 118 Q 179 115 176 116 Q 174.5 119.8 177.5 119 L 177.5 120 L 175 118.5 L 173 111.5 L 174 109.5 L 173 107.5 L 175 106.5 L 175.5 108 L 176 105.5 L 173 103.5 Q 173.8 105.8 171.5 105 Q 167.8 107.3 169 114.5 L 172.5 120 L 174 120.5 L 172 121 L 171.5 123 L 170 122.5 L 174 128.5 L 171 126.5 L 169 122.5 L 170 120.5 L 167 116.5 L 167 112.5 L 167 110.5 L 170 104.5 Q 167.5 103 171 101.5 L 174.5 97 L 184.5 93 Z M 178 96 Q 177 99 180 98 L 183 103 L 184 103 L 183 98 L 178 96 Z M 175 101 L 174 103 L 176 104 L 175 101 Z "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 217.5 98 L 220 98.5 L 217.5 99 L 217.5 98 Z "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 223.5 98 L 226 98.5 L 223.5 99 L 223.5 98 Z "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 101 L 203.5 103 L 201 102.5 L 204.5 101 Z "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 101 L 215 103.5 L 214 103.5 L 214.5 101 Z "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 104 L 188.5 111 L 189 104 L 191 104.5 L 191 112 L 187.5 113 L 187.5 104 Z "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227.5 105 L 230 105.5 L 227.5 106 L 227.5 105 Z "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 219.5 111 L 220 113 L 218 112.5 L 219.5 111 Z "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 118 L 212 121.5 L 211 121.5 L 211.5 118 Z "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 118 L 217.5 120 L 218.5 118 Z "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 124 L 200.5 126 L 201.5 124 Z "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 127 L 198.5 129 L 199.5 127 Z "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 129 L 182.5 132 L 184.5 132 L 187.5 133 L 191.5 132 L 191.5 133 L 184.5 134 L 176.5 131 L 175.5 129 Z "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196.5 129 L 194.5 132 L 193 131.5 L 196.5 129 Z "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 261.5 129 L 262 135.5 L 261 135.5 L 261.5 129 Z "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 137 Q 165 139 161.5 141 L 161.5 139 Q 158.7 139.7 160.5 137 Z "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 140 L 167 143.5 L 166 143.5 Q 166.8 141.3 164.5 142 L 163 142.5 L 164.5 140 Z "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 143 L 169.5 145 L 168.5 143 Z "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 261.5 143 L 262 148.5 L 261 148.5 L 261.5 143 Z "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 145 L 173 145.5 L 170.5 147 L 171.5 145 Z "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 147 L 182 147.5 L 177.5 148 L 177.5 147 Z "
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 148 L 189 148.5 L 186.5 149 L 186.5 148 Z "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 152 L 151 167.5 L 149.5 167 L 132.5 158 L 124.5 153 L 124.5 152 Z "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 259.5 152 L 258.5 154 L 255.5 156 L 257.5 153 L 259.5 152 Z "
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 269.5 152 L 270 154.5 L 269 154.5 L 269.5 152 Z "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 155 L 117.5 158 L 119 158.5 L 117.5 159 Q 113.9 157.9 115.5 155 Z "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 268.5 156 L 266.5 159 L 268.5 156 Z "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 158 L 250 158.5 L 240.5 164 L 241.5 162 L 248.5 158 Z "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 262.5 160 L 261.5 162 L 257.5 164 L 258.5 162 L 262.5 160 Z "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 161 L 151 177.5 L 149.5 177 L 123 163 L 123.5 161 Z "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 164 L 237.5 166 L 228.5 171 L 229.5 169 L 238.5 164 Z "
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 255.5 164 L 254.5 166 L 252.5 167 L 253.5 165 L 255.5 164 Z "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 168 L 163.5 174 L 161.5 170 Q 163.8 169.3 163 171.5 L 166 173.5 L 164 174.5 L 175 181.5 L 173.5 181 L 152.5 169 L 152.5 168 Z "
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 168 L 247.5 170 L 240.5 174 L 241.5 172 L 248.5 168 Z "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 172 L 223.5 174 L 216.5 178 L 217.5 176 L 224.5 172 Z "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 174 L 237.5 176 L 236 175.5 L 238.5 174 Z "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 176 L 232.5 179 L 231 178.5 L 234.5 176 Z "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 210.5 180 L 209.5 182 L 210.5 180 Z "
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227.5 180 L 226.5 182 L 227.5 180 Z "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 182 Q 179.8 181.3 179 183.5 L 177.5 182 Z "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 183 L 204.5 185 L 205.5 183 Z "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 184 L 179 193.5 L 177.5 193 L 165.5 187 L 163.5 184 Z "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 184 L 184 186.5 L 182.5 186 L 180.5 184 Z "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 184 L 218.5 187 L 204.5 194 L 204.5 193 L 220.5 184 Z "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 185 L 203 185.5 L 199.5 188 L 201.5 185 Z "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 188 L 189 189.5 L 187.5 189 L 186.5 188 Z "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 189 L 194.5 191 L 191.5 192 L 190.5 190 L 192.5 191 L 195.5 189 Z "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 195 L 200.5 197 L 198.5 198 L 199.5 196 L 201.5 195 Z "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,25,120)",
    stroke: "rgb(92,25,120)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 196 L 185.5 198 L 184.5 196 Z "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 24 L 201.5 26 L 200.5 24 Z "
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 27 L 208 28 L 209 30.5 L 205.5 28 L 204 28.5 L 205.5 27 Z "
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 28 L 175.5 30 L 176.5 28 Z "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 32 L 195 36 L 200 37.5 L 199 40.5 L 200 40.5 Q 199.1 37.5 203.5 39 L 208 42.5 Q 207.3 46.3 209.5 47 L 215 46 L 215.5 48 L 216.5 47 L 221.5 50 L 226 51.5 L 223 53.5 L 226.5 54 L 228.5 54 L 235 57.5 L 232 58.5 L 232.5 63 L 234 62.5 L 234.5 64 L 236.5 64 L 238 63.5 L 237 60.5 L 237.5 58 L 240 59.5 L 238 60.5 L 240.5 62 L 242 61.5 Q 241.3 63.8 243.5 63 L 248 64 L 248.5 67 L 250 66.5 L 249.5 68 L 252.5 67 L 252.5 71 L 255 70.5 L 254.5 69 L 257 72.5 L 256 75 L 252 76.5 Q 252.8 78.8 250.5 78 L 232.5 87 L 225.5 93 L 219 95 L 218.5 97 L 217 96.5 L 216.5 98 L 215 93.5 L 216 91 L 213 91 Q 214 88 211 89 L 211 86.5 L 206 82.5 L 205.5 84 L 203.5 80 L 197 79.5 L 197.5 78 L 193.5 79 L 191 77.5 L 192 76.5 L 192 48 L 195 46.5 L 192 46 L 193 40.5 L 192 39.5 L 192.5 32 Z M 200 46 L 202 48 Q 203 45 200 46 Z M 219 50 L 220 52 Q 221 49 219 50 Z M 218 53 L 218 55 L 220 54 L 218 53 Z M 228 54 L 225 56 L 228 56 L 228 54 Z M 250 69 L 251 72 L 252 70 L 250 69 Z M 248 76 L 248 78 L 250 77 L 248 76 Z M 194 77 L 194 78 L 196 78 L 194 77 Z "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 33 L 217.5 35 L 215 34.5 L 216.5 33 Z "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 34 L 160.5 36 L 161.5 34 Z "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 219.5 35 L 220.5 37 L 219.5 35 Z "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 38 L 185 39.5 L 183.5 40 L 181.5 38 Z "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 40 L 230.5 42 L 231.5 40 Z "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 41 L 152.5 43 L 153.5 41 Z "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 42 L 210.5 44 Q 207.7 44.7 209.5 42 Z "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 42 L 235 43.5 L 233.5 43 L 232.5 42 Z "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 43 L 145.5 45 L 148.5 44 L 149.5 46 L 147.5 45 L 144.5 47 L 144 44.5 L 145.5 43 Z "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 48 L 133.5 50 L 132 49.5 L 134.5 48 Z "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 48 L 142 49.5 L 140.5 50 L 139.5 48 Z "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 48 L 256 49.5 L 254.5 49 L 253.5 48 Z "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 50 L 253.5 52 L 252.5 50 Z "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 53 L 158.5 55 L 159.5 53 Z "
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 56 L 128 57.5 L 127.5 59 L 127 57.5 L 128.5 56 Z "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256.5 58 L 259 58.5 L 256.5 59 L 256.5 58 Z "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 61 L 142.5 63 L 143.5 61 Z "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 80 L 114 142.5 L 113 142.5 L 113.5 80 Z "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 88 L 157.5 90 L 156.5 88 Z "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 96 L 193.5 98 Q 190.7 98.7 192.5 96 Z "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222.5 98 L 221.5 100 L 222.5 98 Z "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 101 L 200.5 104 L 202.5 104 L 205.5 103 L 205.5 104 L 200 106 Q 201.3 109 197.5 108 Q 196.3 111 192 110 L 193 103.5 L 192.5 102 L 195 103.5 L 195.5 102 L 198.5 104 L 198 102.5 L 198.5 101 Z "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 104 L 230.5 106 L 231.5 104 Z "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 107 L 232 109 L 230 108.5 L 231.5 107 Z "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 112 L 192 128.5 Q 191 131 186.5 130 L 184.5 129 L 183 132 L 181 131.5 L 183.5 128 Q 187.3 128.8 188 126.5 L 187 120 L 189 120.5 L 189 127.5 L 191 128.5 L 191.5 112 Z "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 114 L 208 118 L 211 118.5 Q 209 122 207 117.5 L 207.5 114 Z "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188 115 Q 190.7 113.9 190 116.5 L 188 117.5 L 188 115 Z "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 115 L 232 115.5 L 229.5 117 L 230.5 115 Z "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 119 L 183 119.5 L 179.5 120 L 179.5 119 Z "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 120 L 177 120.5 Q 177.8 122.8 175.5 122 L 174 121.5 Q 174.8 123.8 172.5 123 L 174.5 120 Z "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 124 L 173.5 125 L 175 124.5 L 172.5 126 L 171.5 124 Z "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221 125 L 223 125.5 L 221 126.5 L 221 125 Z "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 217.5 126 L 220 126.5 Q 217.9 129.8 217.5 126 Z "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 129 L 179.5 131 L 178.5 129 Z "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 134 L 155 135 L 157 141.5 L 155 142.5 L 153.5 139 L 152.5 144 L 151 136 L 153 135.5 L 152.5 134 Z "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 136 L 160 139.5 L 158 138.5 L 157.5 136 Z "
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 138 L 213 140 L 215 140.5 L 212 142.5 L 213 140.5 L 212.5 138 Z "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 139 L 162.5 141 L 161.5 139 Z "
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144 140 Q 147 139 146 142 Q 143 143 144 140 Z "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 141 L 164 143.5 L 162.5 144 L 160.5 144 L 158 143.5 L 161 142.5 L 160.5 141 Z "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 260.5 144 L 259.5 146 L 260.5 144 Z "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 145 L 168 147.5 L 168.5 149 L 171.5 147 L 171.5 148 L 169 149.5 Q 170 152 174.5 151 L 174.5 149 L 176 149.5 L 175 147.5 L 176.5 148 L 186 149.5 L 184 150 Q 185.1 152.7 182.5 152 Q 181 149.5 175.5 151 L 176 152.5 Q 175.1 155.5 179.5 154 L 181.5 154 L 184 155.5 L 183.5 158 L 175.5 158 L 165 152.5 L 169 150.5 L 164 149 L 165.5 146 L 169.5 145 Z "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 147 Q 144.3 146.3 145 148.5 L 143.5 154 Q 142.4 151.3 139 152 L 139.5 150 L 141.5 150 Q 145.3 151 144 148 Q 139.6 149 140.5 147 Z "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 148 L 192 150 L 194 150.5 L 188.5 151 L 188.5 150 Q 192 151 191.5 148 Z "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 149 L 129 149 L 131 153 Q 126.4 154.3 125 151.5 L 126.5 149 Z "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 270.5 149 L 272 153.5 L 270 152.5 L 270.5 149 Z "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 152 L 187 175.5 Q 184.3 177.2 186 183.5 L 188.5 185 L 191.5 183 L 192 185 L 189 185.5 L 192 187.5 L 189 187.5 L 189 186 L 186 186 Q 187.1 183.3 184.5 184 Q 183 180.5 181.5 183 L 174.5 179 L 173 179.5 Q 176.8 177.8 173.5 176 L 172 176.5 Q 174.3 177.8 171.5 179 L 169.5 176 L 167.5 177 L 167.5 176 L 169 175.5 L 168 173.5 L 169 171 L 174.5 172 L 177 174.5 L 175 176.5 L 176.5 180 L 181.5 182 L 180 179.5 L 180.5 178 Q 181.6 180.8 185 180 L 186 175.5 L 186.5 152 Z "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 152 L 190.5 176 L 191.5 152 L 192 175.5 L 191 177.5 L 192 179.5 L 190.5 179 L 188 178.5 L 188 160.5 L 189 158.5 L 188 155.5 L 189.5 152 Z "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 153 L 133.5 155 L 132.5 153 Z "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 154 L 131.5 156 L 130.5 154 Z "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 154 L 138 156.5 L 135.5 158 L 133 156.5 L 134.5 156 L 136 156.5 L 136.5 154 Z "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 154 L 164 159.5 Q 160.5 161 163 162.5 Q 165.1 168.3 160.5 167 L 156.5 170 L 156.5 168 Q 152.5 168.5 152 165.5 Q 151.1 162.5 155.5 164 L 160 166 Q 162.1 160.8 157.5 162 L 156.5 160 L 160 158.5 L 161.5 154 Z "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 270.5 155 L 271.5 157 L 270.5 155 Z "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 158 L 142 161.5 L 141 161.5 Q 141.8 159.3 139.5 160 L 140.5 158 Z "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 242.5 158 L 244 158.5 L 241.5 160 L 242.5 158 Z "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 159 L 145 161 L 148.5 160 L 152 162.5 L 149 164 L 148.5 166 L 143 161.5 L 144.5 159 Z M 147 161 L 147 164 L 151 163 L 147 161 Z "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 245.5 159 L 244.5 161 L 245.5 159 Z "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172 160 Q 178 158 176 164 L 172 162.5 L 172 160 Z "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 161 Q 124.5 162.5 121.5 164 L 121.5 161 Z "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 161 L 235.5 163 L 234.5 161 Z "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 262.5 163 Q 265.5 164.5 262.5 166 L 261 166.5 L 261.5 168 Q 258.5 166.5 261.5 165 L 263 164.5 L 262.5 163 Z "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 164 L 235.5 166 L 234.5 164 Z "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 259.5 164 L 258.5 166 L 256.5 167 L 255.5 165 L 257.5 165 L 259.5 164 Z "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 166 L 129 167.5 L 127.5 168 L 125.5 166 Z "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 166 L 131.5 168 L 130.5 166 Z "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 168 L 134.5 170 L 133.5 168 Z "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 168 L 165 170 L 164.5 172 L 161 170 L 161.5 168 Z "
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 170 L 139 171.5 L 137.5 172 L 136.5 170 Z "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 170 L 162 171 L 161.5 173 L 159.5 170 Z "
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 171 L 218.5 174 L 217 173.5 L 220.5 171 Z "
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 173 L 139.5 175 L 141.5 174 L 140.5 176 L 138 174.5 L 139.5 173 Z "
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 176 L 179 178.5 L 177 179 L 177.5 176 Z "
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 176 L 213 176.5 L 210.5 178 L 211.5 176 Z "
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 177 L 208.5 179 L 207.5 177 Z "
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 178 L 148.5 180 L 147.5 178 Z "
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 182 L 204.5 184 L 205.5 182 Z "
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 183 L 203 183.5 L 200.5 185 L 201.5 183 Z "
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 188 L 194.5 190 L 192 189.5 L 193.5 188 Z "
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222.5 188 L 224 188.5 L 223.5 191 L 221 189.5 L 222.5 188 Z "
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 189 L 171 189.5 Q 168.9 192.8 168.5 189 Z "
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 190 L 163 191.5 L 161.5 192 L 160.5 190 Z "
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 197 L 208 198.5 L 206.5 198 L 205.5 197 Z "
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,39,141)",
    stroke: "rgb(111,39,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 200 L 193 201.5 L 191.5 202 L 190.5 200 Z "
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 22 L 195 22.5 L 191.5 23 L 191.5 22 Z "
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 33 L 189.5 35 L 192 36.5 L 190.5 36 L 188 34.5 L 189.5 33 Z "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 194.5 33 L 195.5 35 L 194.5 33 Z "
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 36 L 190 37 L 190.5 43 L 191.5 39 L 193 41.5 L 192 42.5 L 192 76.5 L 190.5 78 Q 186.8 79.3 188 75.5 L 187 75.5 Q 187.8 77.8 185.5 77 L 183.5 77 L 176 78 L 178 74.5 L 176 73.5 L 179.5 72 L 179.5 74 L 185 71.5 L 185.5 69 L 188 70 L 187.5 64 L 185.5 67 L 185 47 L 183 46.5 L 185 46 L 186 42.5 L 182 40.5 L 185 40 Q 186.3 37 182.5 38 L 182.5 37 L 186 38.5 L 186.5 40 L 188 37.5 L 187.5 36 Z M 188 42 L 187 45 L 188 45 L 188 42 Z M 188 48 L 187 56 L 188 56 L 188 48 Z M 189 48 L 190 63 L 190 65 L 189 69 L 191 70 L 191 49 L 189 48 Z "
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 40 L 209 42.5 L 206.5 41 L 205.5 40 Z "
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 41 L 174.5 43 L 173 42.5 L 175.5 41 Z "
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 43 L 179 44.5 Q 179.8 47.1 176.5 46 L 175 46.5 L 175.5 45 L 173.5 46 L 172 45.5 Q 171.3 47.8 173.5 47 L 173.5 48 L 170.5 47 L 166 49.5 L 168 50.5 L 165 53.5 L 166.5 56 L 162.5 55 L 161 55.5 L 160.5 54 Q 157.8 55.2 160 56.5 L 160 58 L 156 58 L 156 59.5 L 155 61.5 L 156.5 61 Q 161.8 59.5 160 64 L 155 64 L 155 62.5 L 152.5 61 L 151.5 64 L 149.5 63 L 148 63.5 L 151 62 L 150.5 60 L 148.5 61 L 149.5 59 L 151 58.5 L 149 57.5 L 152.5 55 L 154.5 56 L 154.5 54 L 156.5 55 L 156.5 53 Q 158.3 56.7 160 53.5 L 158 53 L 158.5 51 L 160 51.5 Q 159.2 48.9 162.5 50 L 166.5 48 L 168 47.5 L 167.5 46 L 176.5 43 Z M 164 50 L 164 52 L 166 51 L 164 50 Z M 161 52 L 161 53 L 163 53 L 161 52 Z "
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 43 L 210.5 45 L 209 44.5 L 211.5 43 Z "
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 46 Q 203.3 45 202 48 L 199.5 46 Z "
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 46 Q 220.2 48 218.5 50 Q 220.8 49.3 220 51.5 L 217.5 50 L 216 49.5 L 218 48.5 L 215 47.5 L 216.5 46 Z "
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 48 L 221.5 50 L 220.5 48 Z "
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 52 L 227 52.5 L 224.5 54 L 225.5 52 Z "
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218 53 L 220 53.5 L 219.5 56 L 218 53 Z "
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 53 L 231 53.5 L 227.5 55 L 228.5 53 Z "
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176 56 L 184 56 L 184 64 Q 178.7 62.8 179.5 66 L 176.5 66 L 176 63.5 L 176 56 Z "
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 237.5 59 L 245 62.5 L 243.5 62 L 238.5 61 L 237.5 59 Z "
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 60 L 147 61.5 L 145.5 61 L 144.5 60 Z "
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233 60 L 235 60 Q 233.9 62.7 236.5 62 L 236.5 63 L 234.5 64 L 234.5 62 L 232.5 63 L 233 61.5 L 233 60 Z "
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 62 L 121 62.5 L 118.5 64 L 119.5 62 Z "
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 62 L 142.5 63 L 144.5 62 L 145.5 64 L 138 63.5 L 140.5 62 Z "
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 64 L 249.5 67 L 251.5 66 L 250.5 68 L 248 66.5 L 248.5 64 Z "
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 65 L 133.5 67 L 134.5 65 Z "
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136 65 L 140 65 L 140 66.5 L 144 70.5 L 142.5 72 L 138.5 70 L 136.5 71 L 134.5 71 Q 132.3 70.3 133 72.5 Q 130.9 76.1 126 76 L 126 78 Q 123.3 76.9 124 79.5 L 123 79.5 Q 122.2 74.2 125 72.5 L 124.5 71 L 126.5 70 L 128.5 71 L 128.5 69 L 130.5 70 L 134.5 68 L 136 68.5 L 136 65 Z "
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 68 L 252.5 70 L 255 70.5 L 252.5 71 L 250 69.5 L 252.5 68 Z "
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 72 L 114 79.5 L 113 79.5 L 113.5 72 Z "
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 270.5 73 L 271 148.5 L 270 148.5 L 270.5 73 Z "
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248 76 L 250 76.5 L 248 77.5 L 248 76 Z "
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 77 L 142 78 Q 143.3 81.3 138.5 80 L 136.5 81 L 133 78.5 L 135.5 77 Z "
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 77 L 196 77.5 L 193.5 78 L 193.5 77 Z "
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 80 L 156 81.5 L 157.5 84 L 161.5 82 L 162 84 L 165 82.5 L 164.5 81 L 170.5 80 L 170.5 81 L 165 83 L 163.5 86 L 160.5 84 L 160 86.5 Q 162.8 88.3 158.5 90 L 158.5 88 L 155 88.5 L 155.5 90 L 153.5 89 L 152 89.5 L 154 85.5 L 152 81.5 L 153.5 80 Z "
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 80 Q 204 79 205 81.5 L 203 82.5 Q 203.9 79.5 199.5 81 L 199.5 80 Z "
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 81 L 128 119.5 L 127 120.5 L 126.5 143 L 126 120 L 123 119.5 L 123 104 L 126 103.5 L 126.5 81 Z "
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144 82 Q 146.7 80.9 146 83.5 Q 148.3 84.8 147 89.5 L 144 91 L 143 86.5 L 144 82 Z "
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 82 L 211 87.5 L 207 84.5 L 206.5 82 Z "
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 89 L 213 91 L 216 91.5 L 213.5 92 L 212.5 89 Z "
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 91 Q 153.8 90.3 153 92.5 Q 150.8 93.8 153.5 95 Q 156.3 93.8 154 92.5 L 154.5 91 L 156 93.5 L 152.5 98 L 152 96 L 148 94.5 L 149 92 L 151.5 91 Z "
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 94 L 192 95 L 190.5 129 L 189 127.5 L 189 120 Q 185.3 118.7 187 124.5 L 188 126.5 L 187.5 129 L 183.5 128 L 180.5 132 L 179.5 130 Q 178.2 132.3 177 129.5 L 176.5 128 Q 174.8 130.8 173 126.5 L 175 126 L 174 121.5 L 174.5 120 Q 170.5 120.5 170 117.5 L 169 108.5 L 171.5 105 Q 173.8 105.8 173 103.5 L 176 102 L 175 104.5 L 176 107.5 L 175 107.5 L 174.5 106 L 173 108.5 L 175 111.5 L 173 111.5 L 175.5 119 L 176 116 Q 179 115 178 118 L 180.5 118 Q 181.6 115.3 185 116 L 184.5 111 L 184 113 L 178 111 L 178 102.5 L 175 99.5 L 177 98.5 L 178.5 101 L 181.5 103 L 185 104 L 184.5 96 Q 183.3 98.3 182 95.5 L 186.5 94 Z M 188 104 L 188 113 L 191 112 L 191 105 L 189 104 L 189 111 L 188 104 Z M 188 115 L 188 118 L 190 117 Q 191 114 188 115 Z M 176 119 L 175 122 L 177 122 L 178 120 L 176 119 Z M 180 119 L 180 120 L 183 120 L 180 119 Z "
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 94 L 216 96.5 L 215 96.5 L 214.5 94 Z "
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178 96 L 183 98 L 184 102.5 L 183 102.5 L 179.5 98 Q 176.9 98.7 178 96 Z "
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 97 L 151 100.5 L 148 105.5 Q 150.8 108.2 150 114.5 L 148 119.5 L 149 121.5 L 148 124 L 150.5 123 L 152 126.5 L 151 126.5 L 150.5 125 L 150 128 L 154 129.5 L 153.5 131 L 152.5 129 L 152 131 L 148 131 L 148 132.5 L 150.5 133 L 153.5 132 L 159 136.5 L 158 138.5 L 161 139.5 L 160 141.5 L 161.5 141 L 166 142 L 166 144 Q 169.8 142.5 169 145.5 L 171 145.5 L 170 148 Q 172.7 149.1 172 146.5 L 173.5 147 L 176 148.5 L 175 150.5 L 181.5 151 L 183 150.5 L 182.5 152 L 185.5 150 L 185.5 149 L 184 148.5 L 185.5 148 L 188.5 149 L 191 148 Q 192.3 151 188.5 150 L 188.5 151 L 192 151.5 L 191 152.5 L 190.5 176 L 189.5 152 L 188 157.5 L 189 159.5 L 188 160.5 L 188 179 L 192 180.5 L 190.5 184 L 189 184.5 L 191 185.5 L 189 186 L 189.5 188 L 191 187.5 L 192 189.5 L 190.5 189 L 183 186 L 182.5 184 L 181.5 185 L 178.5 182 Q 174.1 183.5 175 180.5 L 172 178.5 L 172.5 176 L 174.5 177 Q 179.5 174.5 174.5 172 L 169 171 L 167 175 L 170 176.5 L 169.5 178 L 169 176 Q 164.9 177.7 166 173.5 L 166.5 172 L 164.5 173 L 163 172.5 L 162.5 174 L 162 172.5 L 165 171.5 L 164.5 168 L 163.5 170 L 161 168.5 L 160.5 171 L 156.5 169 Q 151.8 168.8 150 165.5 L 151 163.5 L 149.5 163 L 147.5 164 L 147.5 163 L 149 162.5 L 145.5 161 L 145.5 163 L 143 162.5 L 145 159.5 L 143.5 160 L 140.5 158 L 139.5 160 L 141 160.5 L 139.5 161 L 136 158.5 L 138 155.5 Q 136.7 152.8 135.5 155 L 133.5 156 L 131 154.5 L 133 153.5 L 131 153 L 129 149 L 126.5 149 L 124.5 152 L 123 147.5 L 126.5 146 L 131 147 Q 132.3 144 128.5 145 L 128.5 144 Q 133.9 143.4 136 145 Q 133.8 139.4 139.5 141 L 141 138 L 136 138 L 136 136 L 140.5 136 L 141 138 L 143.5 138 L 147 137 L 144 132.5 L 144 129.5 Q 147.5 128 145 126.5 L 144 120.5 Q 146.9 116.9 146 109.5 L 145 104.5 L 146 104.5 L 146.5 108 L 148 103.5 L 147 99.5 L 148.5 97 Z M 147 116 L 146 122 L 147 122 L 147 116 Z M 155 134 L 151 136 L 153 144 L 154 139 L 155 143 L 157 142 L 155 134 Z M 144 140 Q 143 143 146 142 Q 147 139 144 140 Z M 164 142 L 162 144 L 164 144 L 164 142 Z M 159 143 L 159 144 L 161 144 L 159 143 Z M 166 146 L 164 149 L 167 150 Q 169 149 168 152 L 165 153 L 176 158 L 184 158 L 184 156 L 182 154 L 180 154 Q 175 155 176 153 L 173 151 L 168 149 L 169 147 L 166 146 Z M 141 147 L 141 148 L 144 148 L 141 147 Z M 145 148 Q 145 151 142 150 L 140 150 L 139 152 Q 142 151 144 154 L 145 152 L 145 148 Z M 173 149 L 173 150 L 175 150 L 173 149 Z M 134 152 L 135 153 L 136 154 Q 137 151 134 152 Z M 187 152 L 186 176 L 187 176 L 187 152 Z M 162 154 L 160 159 L 157 160 L 158 162 Q 162 161 160 166 L 156 164 L 151 165 L 158 169 L 161 167 Q 165 168 163 163 Q 160 161 164 160 L 162 154 Z M 172 160 L 172 163 L 176 164 Q 178 158 172 160 Z M 150 161 L 151 162 L 152 163 Q 153 160 150 161 Z M 178 176 L 177 179 L 179 179 L 178 176 Z M 186 176 L 185 180 Q 182 181 181 178 L 180 180 Q 182 184 184 181 L 183 183 L 186 184 L 186 176 Z M 177 180 L 177 181 L 179 181 L 177 180 Z M 187 184 L 186 186 L 189 186 L 187 184 Z "
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 98 Q 197.5 97.5 198 100.5 L 199 103.5 L 197.5 103 L 196 102.5 L 196 100.5 Q 196.8 97.9 193.5 99 L 193.5 98 Z "
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 98 L 211.5 100 L 212.5 98 Z "
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215 98 L 217 98.5 L 215.5 101 L 215 98 Z "
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 102 L 207 102.5 L 202.5 104 L 202.5 103 L 204.5 102 Z "
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 123 L 174 124.5 L 172.5 125 L 171.5 123 Z "
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 219.5 124 L 220.5 126 Q 217.7 126.7 219.5 124 Z "
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 129 L 190.5 131 Q 191.8 128.8 193 131.5 L 189.5 131 Q 186.9 130.3 188 133 L 186 133 Q 187.3 130 183.5 131 L 184.5 129 Z "
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 129 L 215.5 131 L 214.5 129 Z "
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 143 L 114 151.5 L 113 151.5 L 113.5 143 Z "
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 153 Q 130.8 152.3 130 154.5 L 128.5 153 Z "
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 155 L 113.5 157 L 114.5 155 Z "
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 156 L 117.5 158 L 116.5 156 Z "
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 177 L 216 177.5 L 211.5 180 L 212.5 178 L 214.5 177 Z "
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 181 L 207.5 183 L 206 182.5 L 208.5 181 Z "
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(104,33,134)",
    stroke: "rgb(104,33,134)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 197 L 185.5 199 L 184.5 197 Z "
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 16 L 196.5 17 L 198 16.5 L 194.5 18 L 192.5 16 Z "
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 19 L 208 23 L 205 21.5 L 206.5 19 Z "
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 22 L 187.5 24 L 188.5 22 Z "
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 23 L 198.5 25 L 197.5 23 Z "
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184 24 L 186 24.5 L 184 25.5 L 184 24 Z "
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 26 L 200.5 28 L 201.5 26 Z "
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 210.5 31 L 209.5 33 L 210.5 31 Z "
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160 32 L 163 32.5 L 160 34 L 160 32 Z "
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 32 L 196.5 34 L 195.5 32 Z "
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 34 L 169.5 36 L 168.5 34 Z "
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 35 L 201.5 38 L 203 38.5 L 201.5 39 Q 197 37 200.5 35 Z "
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 36 Q 149.3 35 148 38 L 145.5 39 Q 142.5 37.5 145.5 36 Z "
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 219.5 36 Q 222.5 37.5 219.5 39 L 219.5 36 Z "
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 38 L 204.5 40 L 205.5 38 Z "
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222.5 38 L 221.5 40 L 222.5 38 Z "
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 39 L 223.5 41 L 224.5 39 Z "
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 40 L 230 42.5 L 228 43.5 L 228.5 42 L 226.5 40 Z "
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 42 L 155.5 44 L 154.5 42 Z "
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 47 L 144.5 49 L 145.5 47 Z "
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 47 L 222.5 49 L 221.5 47 Z "
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244.5 49 L 246.5 52 L 242 51.5 L 244.5 49 Z "
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119 51 L 126 52.5 L 120.5 54 L 119 51 Z "
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 51 L 227.5 53 L 228.5 51 Z "
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 54 L 249.5 56 L 250.5 54 Z "
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 55 L 132 55.5 L 131.5 58 L 129.5 57 L 129.5 59 Q 126 57 130.5 55 Z "
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 235.5 57 L 236.5 59 L 235.5 57 Z "
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 258.5 59 L 264 60.5 L 261 62.5 L 261.5 61 L 259.5 62 L 259.5 60 L 258.5 59 Z "
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121 60 L 123 60.5 L 121 61.5 L 121 60 Z "
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 264.5 62 L 263.5 64 L 264.5 62 Z "
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 64 L 117.5 66 L 116.5 64 Z "
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 269.5 65 L 270 66.5 L 268.5 69 L 267 66.5 L 269 66.5 L 269.5 65 Z "
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 257.5 68 L 256.5 70 L 257.5 68 Z "
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 259.5 71 L 261 73.5 L 260 73.5 L 259.5 71 Z "
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256 78 Q 259 77 258 80 Q 255 81 256 78 Z "
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 260.5 81 L 261 143.5 L 260 143.5 L 260.5 81 Z "
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 84 L 205.5 86 L 204.5 84 Z "
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 88 L 159.5 92 L 162.5 88 Z "
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 94 L 192.5 96 L 193.5 94 Z "
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 194.5 97 L 199 100.5 L 195.5 98 L 194.5 97 Z "
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 100 L 172.5 102 L 173.5 100 Z "
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227.5 101 L 230 104.5 L 228 105 L 227.5 101 Z "
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 109 L 213 110.5 L 210.5 111 L 209.5 109 Z "
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 110 L 230 110.5 L 225.5 111 L 225.5 110 Z "
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 112 Q 231.8 110.9 231 113.5 L 229.5 113 L 228.5 112 Z "
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 115 L 207 117 L 205 116.5 L 206.5 115 Z "
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 117 L 229 117.5 L 225.5 118 L 225.5 117 Z "
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 119 L 227 121 L 225 121 Q 226.5 124.7 223.5 124 L 220.5 125 L 220.5 124 L 224 122.5 L 223 120.5 L 226.5 119 Z "
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 120 L 210 123.5 L 209 123.5 L 208.5 120 Z "
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 217.5 120 Q 219.8 119.3 219 121.5 L 216 121.5 L 217.5 120 Z "
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 123 L 201 125 Q 198.3 123.9 199 126.5 L 196.5 128 L 196.5 127 Q 198.8 127.8 198 125.5 L 197.5 124 Q 199 126.5 200.5 123 Z "
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 123 L 218 123.5 L 214.5 125 L 214.5 124 L 216.5 123 Z "
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 124 L 170.5 126 L 169.5 124 Z "
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 124 L 209 127.5 L 208 127.5 L 207.5 126 L 206 126.5 L 207.5 124 Z "
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 210 127 L 212 127.5 L 210 128.5 L 210 127 Z "
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 128 L 216 129.5 L 214.5 129 L 212.5 130 L 213.5 128 Z "
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 129 L 195.5 132 Q 192.5 130.5 195.5 129 Z "
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222.5 132 Q 225.5 133.5 222.5 135 L 222.5 132 Z "
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 133 Q 215.8 132.3 215 134.5 L 212 135.5 L 214 136.5 L 211.5 140 L 211 137.5 L 211 135.5 L 213.5 133 Z "
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 135 L 160.5 137 L 159.5 135 Z "
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 140 L 207.5 142 L 208.5 140 Z "
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 141 L 220 142.5 Q 220.9 145.5 216.5 144 Q 213.5 142.5 216.5 141 Z "
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 143 L 203.5 145 L 202.5 143 Z "
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 144 L 201 146.5 L 200 146.5 L 200.5 144 Z "
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256.5 144 L 257.5 146 Q 254.7 146.7 256.5 144 Z "
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 194.5 146 L 199 147.5 L 192.5 149 L 192.5 148 L 195 147.5 L 194.5 146 Z "
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244 148 L 249 148 L 249 150 L 244 150 L 244 148 Z "
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256.5 153 L 257.5 155 L 256.5 153 Z "
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192 154 L 198 154 L 198 156 L 192 156 L 192 154 Z "
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 155 L 253 155.5 L 252.5 158 L 250 156.5 L 251.5 155 Z "
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 267.5 156 L 266.5 158 L 267.5 156 Z "
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 157 L 243 159.5 L 240 159.5 L 241.5 157 Z "
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 159 L 136.5 161 L 135.5 159 Z "
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 261.5 162 L 261 163.5 L 260.5 165 L 258.5 165 L 257 164.5 L 261.5 162 Z "
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 163 L 125 165.5 L 124 165.5 L 124.5 163 Z "
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 164 L 127.5 166 L 126.5 164 Z "
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 254.5 170 L 255 172.5 L 254 172.5 L 254.5 170 Z "
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 172 L 244 174 L 242 173.5 L 243.5 172 Z "
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 173 L 144.5 174 L 146 173.5 L 143.5 175 L 142.5 173 Z "
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 174 L 128 174.5 Q 125.9 177.8 125.5 174 Z "
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 257 174 Q 260 173 259 176 Q 256 177 257 174 Z "
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 176 L 201.5 177 L 203 176.5 Q 202.3 178.8 198.5 178 L 199.5 176 Z "
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 179 L 196 180.5 L 192 183 L 192.5 179 Z "
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227.5 181 L 229 181.5 L 226.5 183 L 227.5 181 Z "
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 183 L 163 185.5 L 161.5 186 L 159.5 183 Z "
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 183 L 203.5 186 L 201.5 185 L 198.5 187 L 198.5 186 L 203.5 183 Z "
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222.5 184 L 224 184.5 L 221.5 186 L 222.5 184 Z "
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 188 Q 216 190 211.5 192 L 210 189.5 L 211.5 190 L 213 189.5 L 212.5 188 Z "
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 189 L 193 190.5 L 191.5 191 L 190.5 189 Z "
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 194 L 203.5 197 L 202 196.5 L 205.5 194 Z "
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 195 L 181.5 197 Q 178.7 197.7 180.5 195 Z "
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 197 L 185.5 200 L 183 199 L 183.5 197 Z "
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176 201 L 179 202.5 Q 179.7 205.5 176 204 L 176 201 Z "
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 201 L 207.5 203 Q 204.7 203.7 206.5 201 Z "
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(117,57,141)",
    stroke: "rgb(117,57,141)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196 206 L 202 206 L 202 208 L 196 208 L 196 206 Z "
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 23 Q 195.9 22.4 198 24 L 197.5 26 Q 196.3 22.7 190.5 24 L 190.5 23 Z "
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182 26 L 185 26.5 L 181.5 29 L 182 27.5 L 182 26 Z "
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 210.5 32 Q 212.8 31.3 212 33.5 L 210.5 32 Z "
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 34 L 186.5 36 Q 183.7 36.7 185.5 34 Z "
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 34 L 204 37.5 L 201.5 38 Q 200.4 35.3 197 36 L 197.5 34 Z "
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 35 L 168 37 L 165.5 38 L 167.5 35 Z "
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 35 L 219 36 L 218.5 38 L 216 37 L 216.5 35 Z "
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 38 L 222.5 40 L 221.5 38 Z "
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 40 L 179 40.5 L 176.5 41 L 176.5 40 Z "
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 40 L 211 41 L 210.5 43 L 207.5 40 Z "
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 43 L 235 45.5 L 232.5 46 L 229.5 43 Z "
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 44 L 221 47.5 L 218.5 48 L 215.5 44 Z "
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 49 L 230 52.5 L 228.5 53 L 224 51 L 224.5 49 Z "
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246.5 53 L 250 54.5 L 248.5 55 L 246.5 53 Z "
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233.5 55 Q 235.8 54.3 235 56.5 L 233.5 55 Z "
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 59 L 245 61.5 L 243.5 61 L 241.5 59 Z "
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256.5 59 L 262 61.5 L 260.5 62 L 256.5 60 L 256.5 59 Z "
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 61 L 137.5 63 L 138.5 61 Z "
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 63 L 249.5 65 L 248.5 63 Z "
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 267.5 65 Q 269.8 64.3 269 66.5 L 267.5 65 Z "
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 66 L 131.5 68 L 132.5 66 Z "
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 66 L 256 67 L 255.5 70 L 253 69 L 253.5 66 Z "
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 260.5 70 L 262 75.5 L 261 75.5 L 260.5 70 Z "
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 269.5 71 L 270 151.5 L 269 151.5 L 269.5 71 Z "
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 85 L 214 93.5 L 213 93.5 L 207 86.5 L 207.5 85 Z "
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 261.5 88 L 262 128.5 L 261 128.5 L 261.5 88 Z "
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 90 L 158.5 93 L 156 92.5 L 158.5 90 Z "
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 94 L 197 96 Q 195.9 98.7 198.5 98 L 201 101.5 L 195.5 97 L 192.5 94 Z "
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 210.5 98 L 212 98.5 L 205.5 102 L 206.5 100 L 210.5 98 Z "
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222.5 100 L 222 101.5 Q 223.5 105.9 220.5 105 L 219 105.5 L 222.5 100 Z "
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227.5 102 L 228 104.5 L 226 105.5 L 227.5 102 Z "
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 104 L 168.5 106 L 169.5 104 Z "
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 110 L 214 112.5 L 211 112.5 Q 210.3 110.3 212.5 111 L 213.5 110 Z "
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 219.5 110 Q 221.8 109.3 221 111.5 L 219.5 110 Z "
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 111 L 230 111.5 L 226.5 113 L 225.5 111 Z "
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 113 L 230 115.5 L 229 115.5 L 229.5 113 Z "
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 117 L 171 123.5 L 170 123.5 Q 170.7 120.9 168 122 L 168 119.5 L 167.5 117 Z "
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 117 L 218.5 120 Q 215.5 118.5 218.5 117 Z "
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 117 L 225 119.5 L 224 119.5 L 224.5 117 Z "
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 217.5 121 L 216.5 123 L 217.5 121 Z "
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 125 L 208 126.5 L 206.5 126 Q 203.5 126.5 204.5 125 Z "
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 126 L 175.5 130 L 177 129.5 Q 175.5 132.5 174 129.5 L 172.5 126 Z "
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 126 L 201 126.5 L 198 128.5 L 196.5 131 L 197 129.5 L 199.5 126 Z "
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 128 L 214 129.5 L 212.5 129 L 211.5 128 Z "
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 131 L 157.5 134 L 159 134.5 L 156 135 L 155 132.5 L 156.5 131 Z "
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 134 L 211 137.5 Q 211.8 139.8 209.5 139 L 206 141.5 L 213.5 134 Z "
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 261.5 136 L 262 142.5 L 261 142.5 L 261.5 136 Z "
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 142 L 205 144 L 203 143.5 L 204.5 142 Z "
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 143 L 172 144.5 L 170.5 145 L 169.5 143 Z "
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 145 L 174.5 147 Q 171.7 147.7 173.5 145 Z "
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 145 L 198.5 147 L 196 146.5 L 199.5 145 Z "
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176 146 L 178 146.5 L 176 147.5 L 176 146 Z "
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 147 L 194 147.5 L 182.5 148 L 182.5 147 Z "
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 261.5 149 L 262 150.5 L 260.5 153 L 260 151.5 L 261.5 149 Z "
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 150 L 124 152.5 L 123 152.5 L 123.5 150 Z "
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 166 L 252 168 L 249.5 169 L 249 167 L 251.5 166 Z "
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 170 L 156.5 172 L 155.5 170 Z "
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 171 L 160.5 173 L 158 172.5 L 159.5 171 Z "
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 178 L 216 178.5 L 213.5 180 L 214.5 178 Z "
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 179 L 159 181.5 L 156.5 182 L 155 180.5 L 155.5 179 Z "
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 180 L 225.5 182 L 226.5 180 Z "
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 182 L 178 183.5 L 176.5 183 L 175.5 182 Z "
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 186 L 187 187.5 L 184 188 L 184.5 186 Z "
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 187 L 199 187.5 L 196 189.5 L 197.5 187 Z "
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 194 L 184 195 Q 185.1 197.7 182.5 197 L 181.5 194 Z "
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202 194 L 205 194.5 L 202.5 196 L 202 194 Z "
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,44,112)",
    stroke: "rgb(92,44,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191 199 L 194 199.5 L 191 201 L 191 199 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCSharp);
export default __webpack_public_path__ + "static/media/CSharp.a0a27c1cbcefea0f30cd1cee5bb7f335.svg";
export { ForwardRef as ReactComponent };